// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_93444fe79c--tooltip--3Um-2","cont":"_93444fe79c--cont--2sCau","text":"_93444fe79c--text--1BNP5"};